/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
class StorageConst{
  static COOKIE_TOKEN = "TOKEN";
  static COOKIE_MODULE_ID = "MODULE_ID";
  static COOKIE_STAFF_NAME = "STAFF_NAME";
  static COOKIE_INSTITUTION_NAME = "INSTITUTION_NAME";
  static LOCAL_INSTITUTION_ID = "INSTITUTION_ID";
  static LOCAL_LOGO_URL = "LOGO_URL";
  static LOCAL_PAGE_LIST = {
    "MATERIAL_MANAGE": "MATERIAL_MANAGE",
    "BOM_MANAGE": "BOM_MANAGE",
    "DISTRIBUTION_CENTER": "DISTRIBUTION_CENTER",
    "KITCHEN_MANAGE": "KITCHEN_MANAGE",
    "ALLOT_PRICE_HANDLE": "ALLOT_PRICE_HANDLE",
    "ALLOT_PRICE_MANAGE": "ALLOT_PRICE_MANAGE",
    "PRODUCE_PRICE_HANDLE": "PRODUCE_PRICE_HANDLE",
    "PRODUCE_PRICE_MANAGE": "PRODUCE_PRICE_MANAGE",
    "PURCHASE_PRICE_HANDLE": "PURCHASE_PRICE_HANDLE",
    "PURCHASE_PRICE_MANAGE": "PURCHASE_PRICE_MANAGE",
    "REQUIRE_PRICE_HANDLE": "REQUIRE_PRICE_HANDLE",
    "REQUIRE_PRICE_MANAGE": "REQUIRE_PRICE_MANAGE",
    "SHOP_MANAGE": "SHOP_MANAGE",
    "STAFF_MANAGE": "STAFF_MANAGE",
    "SUPPLIER_MANAGE": "SUPPLIER_MANAGE",
    "MERCHANT_MANAGE": "MERCHANT_MANAGE",
    "LOG_MANAGE": "LOG_MANAGE"
  };
}




export default StorageConst



// WEBPACK FOOTER //
// ./src/assets/utils/StorageConst.js